import React, { useContext, useEffect, useState } from "react";
import { AiOutlineTeam, AiOutlineHome } from "react-icons/ai";
import { BsRobot } from "react-icons/bs";
import { CgProfile } from "react-icons/cg";
import { FaMoneyBillTrendUp, FaTags } from "react-icons/fa6";
import { IoIosSend } from "react-icons/io";
import { MdPayment, MdPayments } from "react-icons/md";
import { ThemeContext } from "../../../contexts/themeConfig";
import NavLinks from "../../Prompt/NavLink";
import { getUserTeamAccessStatus } from "../../../Utility/service";
import UsersSvg from "../../common/UsersSvg";
import { GrTasks } from "react-icons/gr";

const AdminNavLinks = () => {
  const { theme } = useContext(ThemeContext);
  const checkAccess = getUserTeamAccessStatus();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1020);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1020);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div>
      {isMobile && (
        <NavLinks
          svg={
            <AiOutlineHome
              size={22}
              style={{ color: theme === "light" ? "#000" : "#fff" }}
            />
          }
          text="Home"
          link="/chat"
        />
      )}
      <NavLinks
        svg={<CgProfile size={22} />}
        text="My Profile"
        link="/profile"
      />

      <NavLinks
        svg={
          <UsersSvg />
        }
        text="Users"
        link="/allUsers"
      />

      <NavLinks
        svg={
          <FaMoneyBillTrendUp
            size={22}
            style={{ color: theme === "light" ? "#000" : "#fff" }}
          />
        }
        text="Usage"
        link="/trackUsageList"
      />

      <NavLinks
        svg={
          <GrTasks
            size={22}
            style={{ color: theme === "light" ? "#000" : "#fff" }}
          />
        }
        text="Task Commands"
        link="/taskCommands"
      />

      <NavLinks
        svg={
          <AiOutlineTeam
            size={22}
            style={{ color: theme === "light" ? "#000" : "#fff" }}
          />
        }
        text="Teams"
        link="/allTeams"
      />

      <NavLinks
        svg={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1.5em"
            height="1.5em"
            style={{ color: theme === "light" ? "#000" : "#fff" }}
            className="bi bi-card-list"
            viewBox="0 0 16 16"
          >
            <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z" />
            <path d="M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8zm0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-1-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM4 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z" />
          </svg>
        }
        text="Prompt Templates"
        link="/allTemplist"
      />

      <NavLinks
        svg={
          <FaTags
            size={22}
            style={{ color: theme === "light" ? "#000" : "#fff" }}
          />
        }
        text="Tags"
        link="/allTags"
      />

      <NavLinks
        svg={
          <BsRobot
            size={22}
            style={{ color: theme === "light" ? "#000" : "#fff" }}
          />
        }
        text="Agents"
        link="/allAssistantsList"
      />


      {checkAccess ? (
        <NavLinks
          svg={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1.5em"
              height="1.5em"
              style={{ color: theme === "light" ? "#000" : "#fff" }}
              className="bi bi-file-earmark-bar-graph"
              viewBox="0 0 16 16"
            >
              <path d="M10 13.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v6zm-2.5.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1zm-3 0a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-1z" />
              <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
            </svg>
          }
          text="My Agents"
          link="/users-agents"
        />
      ) : null}

      <NavLinks
        svg={
          <MdPayment
            size={22}
            style={{ color: theme === "light" ? "#000" : "#fff" }}
          />
        }
        text="Upgrade Plan "
        link="/pricing"
      />

      <NavLinks
        svg={
          <MdPayments
            size={22}
            style={{ color: theme === "light" ? "#000" : "#fff" }}
          />
        }
        text="Billing"
        link="/billing"
      />

      <NavLinks
        svg={
          <IoIosSend
            size={22}
            style={{ color: theme === "light" ? "#000" : "#fff" }}
          />
        }
        text="Invite a friend"
        link="/invitation"
      />
    </div>
  );
};

export default AdminNavLinks;
